import http from "../http/http-sritrang-family";
import httpHeader from "../http/http-header";
import httpFooter1 from "../http/http-footer1";
import httpFooter2 from "../http/http-footer2";
// import httpOnetrust from "../http/http-onetrust";
import axios from "axios";

class OnetrustService {
  headerForm() {
    return httpHeader.get("");
  }
  footer1Form() {
    return httpFooter1.get("");
  }
  footer2Form() {
    return httpFooter2.get("");
  }
  getPurpose() {
    return http.get("/suppservice/onetrust/purpose");
  }

  async updateConsentData(data, dataFile) {
    if (dataFile != null) {
      const temp = await this.convertToBase64(dataFile);
      data["pdfBase64"] = temp;
    } else {
      data["pdfBase64"] = "";
    }
    return await axios.post(
      "/suppservice/onetrust/updateconsentdatabase64",
      data
    );
  }

  convertToBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.onload = async function (fileLoadedEvent) {
        try {
          const base64 = fileLoadedEvent.target.result;
          resolve(base64);
        } catch (e) {
          reject(e);
        }
      };
      reader.readAsDataURL(file);
    });
  }
}

export default new OnetrustService();
